import { jwtDecode } from 'jwt-decode';

/**
 * Decode permissions from either user object or token
 */
const getUserWithPermissions = () => {
  try {
    const userString = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    let user = userString ? JSON.parse(userString) : {};

    // If no permissions in user object, try decoding token
    if ((!user.permissions || !user.fullAdminPrivileges) && token) {
      const decoded = jwtDecode(token);
      user = { 
        ...user, 
        ...decoded,
        // Ensure permissions and fullAdminPrivileges from token are merged
        permissions: user.permissions || decoded.permissions,
        fullAdminPrivileges: user.fullAdminPrivileges !== undefined 
          ? user.fullAdminPrivileges 
          : decoded.fullAdminPrivileges
      };
    }

    return user;
  } catch (error) {
    console.error('Error decoding user/token:', error);
    return {};
  }
};

/**
 * Check if a user has a specific permission
 */
export const hasPermission = (user, module, action) => {
  if (user?.role === 'admin') return true;

  if (user?.role === 'sub-admin') {
    // Check if sub-admin has full admin privileges
    if (user?.fullAdminPrivileges === true) return true;
    
    // Otherwise check specific permissions
    if (user?.permissions) {
      return user.permissions[module]?.[action] === true;
    }
  }

  return false;
};

/**
 * Get current user with permissions
 */
export const getCurrentUser = () => getUserWithPermissions();

/**
 * Role checkers
 */
export const isAdmin = () => getCurrentUser()?.role === 'admin';
export const isSubAdmin = () => getCurrentUser()?.role === 'sub-admin';
export const isPersonnel = () => getCurrentUser()?.role === 'personnel';
export const isSuperAdmin = () => getCurrentUser()?.role === 'super-admin';

/**
 * Check if current user has permission
 */
export const currentUserHasPermission = (module, action) => {
  const user = getCurrentUser();
  return hasPermission(user, module, action);
};

export default {
  hasPermission,
  getCurrentUser,
  isAdmin,
  isSubAdmin,
  isPersonnel,
  isSuperAdmin,
  currentUserHasPermission
};
